var map = {
	"./arab_workspace.jpeg": 2245,
	"./c-flow.avif": 8276,
	"./custom-software.avif": 5491,
	"./environmental-monitoring.png": 1629,
	"./g2-dsf.png": 3625,
	"./iVisita.avif": 7561,
	"./meeting-room.avif": 4215,
	"./paperless-board-meeting.avif": 1818,
	"./png/c-flow.png": 46,
	"./png/custom-software.png": 4629,
	"./png/iVisita.png": 4171,
	"./png/meeting-room.png": 531,
	"./png/paperless-board-meeting.png": 5882,
	"./s-cs.png": 104,
	"./s-ivisita.png": 7119,
	"./s-keyp.png": 1809,
	"./s-meeting.png": 3983,
	"./s-vms.png": 7582,
	"./s1.png": 9510,
	"./s2.png": 717,
	"./s3.png": 4036,
	"./slider-it-solutions.avif": 6572,
	"./slider2.jpg": 6287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8860;